import { makeCrudStateSelectors } from "seneca-common/utils/apiStates";

import { passwordResetCrudStateConfig } from "../consts";
import PasswordResetState from "../models/PasswordResetState";
import SignInState from "../models/SignInState";
import User from "../models/User";
import UserStateSlice from "../models/UserStateSlice";

export function getUserSlice(state: any): UserStateSlice {
  return state.get("user");
}

export function getUserDetails(state: any): User {
  return getUserSlice(state).user;
}

export function getUserId(state: any) {
  return getUserDetails(state).userId;
}

export function getUserDisplayName(state: any) {
  return getUserDetails(state).displayName;
}

export function getUserEmail(state: any) {
  return getUserDetails(state).email;
}

export function getUserGivenName(state: any) {
  return getUserDetails(state).givenName;
}

export function getUserFamilyName(state: any) {
  return getUserDetails(state).familyName;
}

export function getUserYearGroup(state: any) {
  return getUserDetails(state).yearGroup;
}

export function getUserPhoneNumber(state: any) {
  return getUserDetails(state).phoneNumber;
}

export function getUserAccountType(state: any) {
  return getUserDetails(state).type;
}

export function getTeacherRole(state: any) {
  return getUserDetails(state).teacherRole;
}

export function getUserNickName(state: any) {
  return getUserDetails(state).nickname;
}

export function getUserManagedBy(state: any) {
  return getUserDetails(state).managedBy;
}

export function isUserManaged(state: any): boolean {
  return !!getUserManagedBy(state);
}

export function getUserExternalSchoolId(state: any) {
  return getUserDetails(state).externalSchoolId;
}

export function getUserChosenSchool(state: any) {
  return getUserDetails(state).school;
}

export function getUserSignInState(state: any): SignInState {
  return getUserSlice(state).signInState;
}

export function isSignedIn(state: any): boolean {
  return getUserSignInState(state).signedIn;
}

export function isSigningIn(state: any): boolean {
  return getUserSignInState(state).signingIn;
}

export function isSigningOut(state: any): boolean {
  return getUserSignInState(state).signingOut;
}

export function isSignedInAsGuest(state: any): boolean {
  return getUserSignInState(state).signedInAsGuest;
}

export function userHasSignedInBefore(state: any): boolean {
  return getUserSignInState(state).hasSignedInBefore;
}

export function isFirstUserSession(state: any): boolean {
  return getUserSignInState(state).isFirstSession;
}

export function credentialsRefreshHasErrored(state: any): boolean {
  return getUserSignInState(state).refreshCredentialsError;
}

export function getPasswordResetSlice(state: any): PasswordResetState {
  return getUserSlice(state).passwordReset;
}

export function getPasswordResetEmail(state: any) {
  return getPasswordResetSlice(state).email;
}

export function getUserMetaSlice(state: any): any {
  return getUserSlice(state).meta;
}

export function getPasswordResetMetaState(state: any) {
  return getUserMetaSlice(state).passwordReset;
}

const passwordResetMetaSelectors = makeCrudStateSelectors(
  getPasswordResetMetaState,
  passwordResetCrudStateConfig
);

export function getResubmitCodeError(
  state: any,
  email: string
): string | null | undefined {
  return passwordResetMetaSelectors.update.getErrorMessage(state);
}

export function getResubmitCodePending(state: any, email: string): boolean {
  return passwordResetMetaSelectors.update.getStarted(state, email);
}

export function getResubmitCodeSuccess(state: any, email: string): boolean {
  return passwordResetMetaSelectors.update.getSuccess(state, email);
}
